/**
 * 兼容状态栏高度组件
 */
import React from 'react';
import styles from './index.css';
import Grounds from '../../index';
const getStateBarHeight = () => {
    var _a;
    const isAndroid = /android/i.test(Grounds.getDeviceInfo().getOs());
    const height = (_a = window.grounds) === null || _a === void 0 ? void 0 : _a.getStatusBarHeight();
    if (!height)
        return '0px';
    const stateBarHeight = height / (isAndroid ? window.devicePixelRatio : 1);
    return `${stateBarHeight}px`;
};
export const SafeHeader = ({ children, headerStyle = '' }) => {
    const stateBarHeight = getStateBarHeight();
    return React.createElement("div", { className: `${styles.safeHeader} ${headerStyle}`, style: {
            paddingTop: stateBarHeight
        } }, children);
};
